import COLORS from '@/constants/colors';

const fakeInput = {
  WebkitTextFillColor: '#616161 !important',
  cursor: 'not-allowed',
  pointerEvents: 'none',
  '& fieldset': {
    border: '1px solid #E5E9F2',
  },
};

export default {
  wrapper: {
    mb: '16px',
    '& .MuiInputBase-root': {
      backgroundColor: '#FFFFFF',
    },
    '& .input-fake .MuiInputBase-root': fakeInput,
    '& .input-fake .MuiInputBase-input': fakeInput,
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '16px',
    color: COLORS.gray_700,
  },
};
